// src/components/PageHeroTitle.jsx
import React from 'react'

const PageHeroTitle = ({ title, description }) => {
  return (
    <div className="hero text-center py-5">
      <h1 className="mb-3">{title}</h1>
      {description && <p>{description}</p>}
    </div>
  )
}

export default PageHeroTitle
